import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getForcedGlobalClassnamesForContext, getComponentName } from './helpers';
import { ThemeOptions, ThemeSkin, ThemeSurface } from './constants';
import { FlagContext } from './flags/FlagContext';
export const ThemeContext = /*#__PURE__*/ React.createContext(undefined);
ThemeContext.displayName = 'ThemeContext';
export const ThemeSkinContext = /*#__PURE__*/ React.createContext(undefined);
ThemeSkinContext.displayName = 'ThemeSkinContext';
export const ThemeSurfaceContext = /*#__PURE__*/ React.createContext(undefined);
ThemeSurfaceContext.displayName = 'ThemeSurfaceContext';
export function useSelectByTheme({ dark, light, green = light }) {
    const theme = useContext(ThemeContext);
    const themeSkin = useContext(ThemeSkinContext);
    if (theme === ThemeOptions.DARK) {
        return dark;
    }
    if (themeSkin === ThemeSkin.GREEN) {
        return green;
    }
    return light;
}
// HOC for convenience...
export function withThemeContext(Component) {
    const DecoratedComponent = (props)=>{
        const theme = useContext(ThemeContext);
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            theme: theme
        }, props));
    };
    DecoratedComponent.displayName = `withThemeContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}
// and for overriding theme...
export const ThemeOverride = (_param)=>{
    var { children, theme = 'match', themeSkin, themeSurface = ThemeSurface.PRIMARY, className, tag: Tag = 'span' } = _param, rest = _object_without_properties(_param, [
        "children",
        "theme",
        "themeSkin",
        "themeSurface",
        "className",
        "tag"
    ]);
    const flags = useContext(FlagContext);
    if (theme === 'match') {
        return /*#__PURE__*/ React.createElement(Tag, _object_spread({
            className: classnames(className, 'surface', themeSurface)
        }, rest), children);
    }
    return /*#__PURE__*/ React.createElement(ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ React.createElement(Tag, _object_spread({
        className: classnames(className, getForcedGlobalClassnamesForContext({
            theme,
            themeSkin,
            themeSurface,
            flags
        }))
    }, rest), children));
};
ThemeOverride.displayName = 'ThemeOverride';
export const useReverseTheme = ()=>{
    const theme = useContext(ThemeContext);
    return theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT;
};
export const ReverseTheme = ({ children, className, tag })=>{
    const flippedTheme = useReverseTheme();
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: flippedTheme,
        className: className,
        tag: tag
    }, children);
};
ReverseTheme.displayName = 'ReverseTheme';
// re-export to avoid changing a billion imports again...
export { ThemeOptions, ThemeSkin, ThemeSurface };
